import { render, staticRenderFns } from "./review.vue?vue&type=template&id=a26e9010&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=a26e9010&prod&scoped=true&lang=scss&"
import style1 from "./review.vue?vue&type=style&index=1&id=a26e9010&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26e9010",
  null
  
)

export default component.exports